import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AceEditorModule } from 'ng2-ace-editor';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BasicLayoutRoutes, layoutRoutings } from './basic-layout.routing';
import { ComponentsModule } from '../../components/components.module';
import { HeaderModule } from 'src/app/components/header/header.module';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { DateModule } from 'src/app/date/date.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { MainLayoutComponent } from '../main-layout/main-layout.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  imports: [
    ComponentsModule,
    CommonModule,
    RouterModule.forChild(BasicLayoutRoutes),
    FormsModule,
    HeaderModule,
    FooterModule,
    TabsModule.forRoot(),
    BsDropdownModule.forRoot(),
    AceEditorModule,
    NgxPaginationModule,
    ModalModule.forRoot(),
    DateModule,
    NgbModule,
    AccordionModule,
    NgxSpinnerModule  
  ],
  declarations: [
    layoutRoutings,
  ]
})

export class BasicLayoutModule { }
